import React from 'react';
import { theme } from '../utils/theme';

export default function Button(props){
    return (
        <button style={{...styles.button,...props.style}} onClick={props.onClick}>
            {props.children}
        </button>
    );
};
const styles = {
    button:{
        padding: '1rem 4rem',
        borderRadius: '0.5rem',
        border: 'none',
        backgroundColor: theme.primary,
        color: theme.text,
        cursor: 'pointer',
        fontSize: '1rem',
        height: 'fit-content',
        boxShadow: '0px 0px 4px 2px #00000022',
    }
}